export default "__VITE_ASSET__1KvHKbdX3WTSSJV1kBnQ3w__"